import { style } from '@angular/animations';
import { DizionarioModel } from '../../models/shared/dizionario.model';
import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
// import { ToastsManager } from 'ng2-toastr/ng2-toastr';

import { MdSnackBar } from "@angular/material";
import { AppComponent } from '../../app.component';
import { IResetModel } from "../../models/account/ilogin-reset.model";
import { AuthService } from './../../services/auth.service';
import { IResetRichiestaModel } from "../../models/account/ilogin-reset-richiesta.model";
import { LangService } from '../../services/lang.services';


@Component({
  selector: 'account-richiesta-reset',
  moduleId: module.id,
  templateUrl: './account-richiesta-reset.component.html',
  styles: ['.loginbox { min-width: 320px; max-width: 360px; margin: 0 auto;}']
})

export class AccountRichiestaResetComponent implements OnInit {
  model: any = {};
  loading = false;
  returnUrl: string;
  resetForm: FormGroup;
  ruoli: DizionarioModel[] = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthService,
    private formBuilder: FormBuilder,
    private snackBar: MdSnackBar,
    private _vcr: ViewContainerRef,
    private appComponent: AppComponent,
    private _langService:LangService
    ) {

  }

  ngOnInit() {
    // reset login status
    //this.authenticationService.logout(false);
    this._langService.setLang('it');
    this.buildForm();
  }

  //SUBMIT
  onSubmit() {
    this.loading = true;
    if (this.resetForm) {
      this.authenticationService.resetRichiediPassword(this.resetForm.value as IResetRichiestaModel)
        .finally(() => {
          this.loading = false;
        })
        .subscribe(
        (data: any) => {
          if (data.hasEmailSent) {
            this.showWarning("E' stata inviata una email con indicata la procedura da seguire per il recupero della password");
          } else {
            this.showError(data.messaggio);
          }

        },
        error => {
          this.showWarning(error);
        });

    }
  }

  //MSG
  private showError(message: string) {
    this.snackBar.open("Errore: " + message, 'Chiudi', { duration: 2000 });
    console.log(message);
  }

  private showWarning(message: string) {
    this.snackBar.open(message, 'Chiudi', { duration: 2000 });
    console.log(message);
  }

  //FORM
  buildForm(): void {
    this.resetForm = this.formBuilder.group({
      username: [null, Validators.required],
      email: [null, Validators.required],
    });

  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/account/account-richiesta-reset.component.ts